/** @format */

import React from 'react'
import styled from 'styled-components'
import variable from 'src/static/styles/var'

/** AgentKit 趋势图统一固定高度 */
export const CHART_COL_HEIGHT = 300

export interface ChartsSectionProps {
  className?: string
  'aria-label'?: string
  children?: React.ReactNode
}

const ChartsSection: React.FC<ChartsSectionProps> = ({
  className,
  'aria-label': ariaLabel,
  children
}) => (
  <section className={className} aria-label={ariaLabel}>
    {children}
  </section>
)

export default styled(ChartsSection)`
  margin-top: 24px;
  border-top: 1px solid ${variable.borderColor};
  padding-top: 8px;

  .overview-chart-col {
    margin-top: 16px;
  }
`
